import { Loader } from "@googlemaps/js-api-loader";

const API_KEY = process.env.GOOGLE_MAPS_API_KEY
const contactMap = document.getElementById("contactMap");

var lat = 52.478680;
var long = -1.885098;

const loader = new Loader({
  apiKey: API_KEY,
  version: "weekly",
});

if(contactMap){

  loader.load().then(async () => {
    async function initMap() {
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
  
      const styledMapType = new google.maps.StyledMapType([
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e6f1f8",
                "stroke": "#98bad1"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "geometry.stroke",
            "stylers": [
              {
                "color": "#98bad1"
              }
            ]
          },        
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#cbe5f6",
                "stroke": "#98bad1"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#cbe5f6"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#cbe5f6"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "color": "#f8dfa2"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#cbe5f6"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ],{ name: "Map" });
  
  
      // Set up map
      const map = new Map(document.getElementById("contactMap"), {
        center: { lat: lat, lng: long },
        zoom: 14,
        mapId: "google.maps.MapTypeId.ROADMAP",
        mapTypeControlOptions: {
          mapTypeIds: ["satellite", "hybrid", "styled_map"],
        },      
      });
  
      map.mapTypes.set("styled_map", styledMapType);
      map.setMapTypeId("styled_map");
      
  
      // Set up custom marker    
      const parser = new DOMParser();
      const pinSvgString =
        '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="48" viewBox="0 0 36 48"><defs><linearGradient id="linear-gradient" x1="9.13" y1="12.46" x2="24.06" y2="21.07" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffdd8c"/><stop offset="1" stop-color="#fff"/></linearGradient></defs><g><path d="M36,18c0,9.94-16,30-18,30S0,27.94,0,18,8.06,0,18,0s18,8.06,18,18Z" style="fill: #303e4e;"/><path d="M27.13,9.34h0v-.05s0,.03,0,.05ZM24.6,6.79c-.07,0-.13,0-.2,0h.39c-.06,0-.13,0-.19,0ZM27.12,9.12c0-.1-.02-.19-.04-.29-.13-.68-.54-1.28-1.12-1.65-.17-.11-.36-.2-.55-.26-.19-.06-.41-.12-.61-.12h-.39c-.52.04-1.01.24-1.4.56h0c-.97.79-2.22,1.13-3.44.94-.09-.01-.17-.03-.24-.04-.46-.1-.9-.27-1.31-.51-.29-.18-.63-.28-.98-.28-1.04,0-1.88.85-1.88,1.89s.84,1.89,1.88,1.89c.34,0,.68-.1.97-.27.41-.24.85-.42,1.31-.52.06-.01.15-.03.24-.04,1.22-.2,2.47.14,3.44.91h.01c.45.38,1,.58,1.59.58.1,0,.21,0,.31-.02.4-.05.8-.2,1.13-.43.33-.23.6-.53.79-.88.24-.44.34-.95.3-1.44h0ZM6.88,16.92v.26s0-.08,0-.13,0-.09,0-.13ZM6.88,24.53v.26s0-.09,0-.13,0-.08,0-.13ZM9.54,27.21s-.09,0-.13,0-.09,0-.13,0h.26ZM16.62,22.84c-.42.09-.79.32-1.19.49-.4.17-.82.28-1.25.32-1.23.12-2.6-.23-3.32-1.31-.53-.8-.61-1.88-.19-2.75.13-.26.31-.51.53-.74.86-.86,2.17-1.08,3.25-.53.26.13.51.31.74.53.48.48,1.12.75,1.79.75,1.4,0,2.54-1.14,2.54-2.55s-1.14-2.55-2.54-2.55c-.68,0-1.32.27-1.79.75-.22.22-.47.4-.74.53-1.09.54-2.4.33-3.25-.53-.48-.48-1.12-.75-1.79-.75-1.35,0-2.47,1.07-2.53,2.41v.26c.03.64.29,1.23.74,1.67.23.23.4.48.53.74.54,1.09.33,2.41-.53,3.27-.45.45-.71,1.04-.74,1.67v.26c.07,1.3,1.11,2.35,2.4,2.41h.26c.54-.03,1.04-.22,1.46-.56,1.22-.99,2.96-1.27,4.41-.63.39.17.75.4,1.16.49.72.17,1.53-.15,1.96-.76.21-.31.32-.69.32-1.07,0-.37-.1-.73-.3-1.04-.41-.62-1.22-.95-1.94-.8ZM24.26,15.1c-1.03,0-1.87.84-1.87,1.88s.84,1.88,1.87,1.88,1.87-.84,1.87-1.88-.84-1.88-1.87-1.88Z" style="fill: url(#linear-gradient);"/></g></svg>';
      const pinSvg = parser.parseFromString(
        pinSvgString,
        "image/svg+xml"
      ).documentElement;
      const marker = new AdvancedMarkerElement({
        map,
        position: { lat: lat, lng: long },
        content: pinSvg,
      });
      
  
  
    }
    initMap();
  });

}



